// Longest edge of an uploaded photo. A 12MP phone photo is 4032px wide and
// several MB; at 1600px it is still sharper than any card or bubble shows
// and a fraction of the bytes (issue #414).
export const MAX_UPLOAD_EDGE = 1600;

// The manipulator resize action that brings the longest edge down to
// MAX_UPLOAD_EDGE keeping the aspect ratio (give one side, it derives the
// other), or undefined when the image already fits.
export function resizeTarget(width: number, height: number): { width: number } | { height: number } | undefined {
  if (Math.max(width, height) <= MAX_UPLOAD_EDGE) return undefined;

  return width >= height ? { width: MAX_UPLOAD_EDGE } : { height: MAX_UPLOAD_EDGE };
}
